// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"f6019a2d","420":"2d8cc1c0","453":"7f2d1cd7"}[chunkId] + ".chunk.js";
};